module.exports = __webpack_public_path__ + "static/media/bckg.a6e0db39.jpg";